import { Typography } from "@mui/material";

import { type Insight, RiskTypes } from "../../Insights/types";
import { totalCustomProblems, totalRisks } from "../../Insights/utils";
import { AmountInCustomerCurrency } from "./AmountInCustomerCurrency";
import { getInsightPotencialSavings } from "./utils";

export const InsightImpact = ({ insight }: { insight: Insight }) => {
  const potentialDailySavings = getInsightPotencialSavings(insight);

  const customProblems = totalCustomProblems(insight);

  const risks = RiskTypes.map((risk) => ({
    label: risk.label,
    value: totalRisks(insight, risk.key),
  }));

  const activeRisk = risks.find((risk) => risk.value);

  if (potentialDailySavings) {
    return (
      <Typography variant="body2" sx={{ fontWeight: 500 }} noWrap>
        <AmountInCustomerCurrency amount={potentialDailySavings} /> at risk
      </Typography>
    );
  } else if (activeRisk) {
    return (
      <Typography variant="body2" sx={{ fontWeight: 500 }} noWrap>
        {activeRisk.value} {activeRisk.label.toLowerCase()}
      </Typography>
    );
  } else if (customProblems) {
    const customProblemsUnits =
      (customProblems === 1
        ? insight.results?.customProblems?.unitLongSingular
        : insight.results?.customProblems?.unitLongPlural) ?? "";
    return (
      <Typography variant="body2" sx={{ fontWeight: 500 }} noWrap>
        {customProblems} {customProblemsUnits}
      </Typography>
    );
  }
  return null;
};
